type FirebaseConfig = {
  apiKey: string
  appId: string
  authDomain: string
  measurementId: string
  messagingSenderId: string
  projectId: string
  serviceAccountId: string
  storageBucket: string
}

export const firebaseConfig: FirebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY as string,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID as string,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN as string,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID as string,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID as string,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID as string,
  serviceAccountId: process.env.NEXT_PUBLIC_FIREBASE_SERVICE_ACCOUNT_ID as string,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET as string,
}
